import { useState } from "react";
import { 
    Card, 
    CardActionArea, 
    CardContent, 
    CardMedia, 
    Typography, 
    Box, 
    Skeleton 
} from "@mui/material";

export default function ExperienceCard({ asset, onClick }) {
  const [imageLoaded, setImageLoaded] = useState(false);

  return (
    <Card
      sx={{ backgroundColor: "primary.main" }}
      className="!rounded-xl w-full max-w-[380px] overflow-hidden shadow-md hover:shadow-lg transition-all duration-300 text-white h-[430px]"
    >
      <CardActionArea onClick={onClick}>
        {/* Header */}
        <Box className="py-4 px-4">
          <Typography variant="h6" component="div" className="text-white !font-semibold truncate">
            {asset.Title}
          </Typography>
        </Box>

        {/* Lazy-loaded Image */}
        {!imageLoaded && <Skeleton variant="rectangular" height={256} animation="wave" />}
        <CardMedia
          component="img"
          image={asset.Image}
          alt={asset.Title}
          loading="lazy"
          onLoad={() => setImageLoaded(true)}
          className={`h-64 !m-auto !bg-cover !bg-center !object-contain transition-opacity duration-300 ${
            imageLoaded ? "opacity-100" : "opacity-0"
          }`}
        />

        {/* Content */}
        <CardContent className="text-white px-4 py-10">
          <Typography variant="body2" className="line-clamp-3 leading-relaxed text-sm">
            {asset.Heading}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}
